import { defaultColDefs } from '@/utils/grid-utils/colDefs'
import { ColDef } from '@ag-grid-community/core'

export const FONT_WEIGHT_700 = { fontWeight: 700 }

export const UNSAVED_CHANGES_MESSAGE =
  'You have unsaved changes. If you leave this page,' +
  'your changes will be lost. Do you still want to start new optimization?'
export const DUPLICATE_TEMPLATE_NAME_MESSAGE =
  'Template name already exists. ' +
  'Are you sure you want to overwrite the template?'

export const OPERATORS = [
  { id: '<=', label: 'Less than or Equal to (<=)' },
  { id: '==', label: 'Equals (==)' },
  { id: '>=', label: 'Greater than or Equal to (>=)' },
]

export const optimizationDefaultColDefs: ColDef = {
  ...defaultColDefs,
  filter: 'agTextColumnFilter',
  menuTabs: ['generalMenuTab'],
  flex: 1,
  floatingFilter: true,
}

export const COUPONS_OPTIONS = [
  'All Coupon',
  'Half Coupons Excluded',
  'Half Coupons Only',
]

export const REFUNDING_DATE_OPTIONS = [
  'No Selection',
  'Refundable Securities Only',
  'Non-Refundable Securities Only',
]

export const PUT_DATE_OPTIONS = [
  'No Selection',
  'Putable Securities Only',
  'Non-Putable Securities Only',
]

export const CALLDATE_OPTIONS = [
  'No Selection',
  'Callable',
  'Callable, Make Whole',
  'Callable, Non-Make Whole',
  'Non-Callable',
  'Non-Callable Life',
]

export const MIN_MAX_DOUBLE_OPTIONS = [
  ...Array.from({ length: 30 }, (_, index) => `NUMITEM${index + 1}`),
  ...Array.from(
    { length: 30 },
    (_, index) => `EXPRNUM${(index + 1).toString().padStart(2, '0')}`,
  ),
]
// liabilityReinvestmentTaxes
export const ACCEPTED_FILE_FORMATS_FOR_LIABILITY_REINVESTMENT_TAXES = [
  '.flw',
  '.rat',
  '.csv',
]

export const MIN_MAX_FLOAT_OPTIONS = [
  'AVGLIFE',
  'BETA',
  'BP',
  'DTE',
  'MODDTE',
  'YTE',
  'CONVEX',
  'DTS',
  'DURTCALL',
  'DUR',
  'DURTW',
  'EP',
  'EDUR',
  'ED2',
  'ED3',
  'ESPREAD',
  'LNMCAP',
  'CYLD',
  'WSPREAD',
  'WSPDEDUR',
  'VOLTY',
  'VOLELAST',
  'YRTOCALL',
  'YRTOEXMT',
  'YRTOMATU',
  'YRMUNIMT',
  'YLDTC',
  'YLD',
  'YTP',
  'YLDTW',
  'MODDUR',
  'MDURTW',
  'MOMENTUM',
  'PER',
  'PRICE',
  'PBR',
]

export const INFO_STRUCT_OPTIONS = [
  'ASSETNM',
  'BCRATING',
  'BCAVGRATE',
  'BCSECT1',
  'BCSECT2',
  'BCSECT3',
  'BCSECT4',
  'CURRENCY',
  'CLCLASS',
  'COUNTRY',
  'CNTYINC',
  'COUNTRYI',
  'COUNTRYR',
  'CNTYRISK',
  'MSINDUS',
  'MSINDGRP',
  'MSSECT',
  'MSSUBIND',
  'HQUAL',
  'HQUALB',
  'ITYPE',
  'ITYPE2',
  'MUNIOID',
  'MUNISECT',
  'MUNIAMT',
  'PMTBASNM',
  'PMTFREQ',
  'PRCSRC',
  'REGION',
  'REGIONGR6',
  'SANDP',
  'SECTOR',
  'STATENAM',
  'RESFRQNM',
  'RLOWQUALB',
  'RLOWQUAL',
  'LOWQUAL',
  'MLSECT1',
  'MLSECT2',
  'MLSECT3',
  'MLSECT4',
  'MOODY',
  'MOODYB',
]

export const USER_INPUT_OPTIONS = [
  'ASTSCLS',
  'ASTCLS',
  'ASTCLS2',
  'ASTCLS3',
  'MLTICKER',
  'CUSIP',
  'ISIN',
  'ISSUER',
  'SECTOR2',
  'GUARANTOR',
  'SEDOL',
  ...Array.from(
    { length: 30 },
    (_, index) => `EXPRTXT${(index + 1).toString().padStart(2, '0')}`,
  ),
]
